<template>
  <v-card :style="`${(width!=='')?'width:'+width+';':''}`" :loading="loading" class="align-stretch" height="100%">
    <v-card-title v-if="heading">
      {{cardHeading}}
      <v-spacer></v-spacer>
      <v-btn color="secondary" x-small @click="$emit('open-create')" :disabled="disableAddLead"><v-icon small>add</v-icon> Add Lead</v-btn>
    </v-card-title>
    <v-card-text v-if="!loading">
      <v-data-table :headers="headers" :items="body" disable-filtering :options.sync="options" :footer-props="{itemsPerPageOptions}">
        <template v-if="body.length > 0" v-slot:body="{ items }">
          <tbody>
            <template v-for="(item,i) in items">
              <tr :key="i" @click="goto(item.id)" style="cursor: pointer;">
                <td><span class="body--text">{{ item.created | formatDateWithoutTime }}</span></td>
                <td><span class="body--text">{{ item.agent | username }}</span></td>
                <td><span class="body--text">{{ item.status }}</span></td>
                <td><span class="body--text">{{ item.saved }}</span></td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
  import session from './../../api/session';
  import { mapState, mapActions } from "vuex";

  export default {
    data: () => ({
      headers: [
        { text: 'Created',  value: 'created', sortable: false },
        { text: 'Agent', value: 'agent', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Saved', value: 'saved', sortable: false }
      ],
      body: [],
      retentionHistory: {},
      cardHeading: 'Retention History',
      loading: true,
      options: {
        page: 1,  
        itemsPerPage: 10,
        sortBy: ['created'],
        sortDesc: [true],
      },
      itemsPerPageOptions: [5,10,25,50]
    }),
    // eslint-disable-next-line
    props: {
      id: '',
      heading: true,
      filter: false,
      width: '',
      disableAddLead: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ...mapState("accounts", ["crmUsers"])
    },
    methods: {
      goto(id){ this.$router.push(`/retention/${id}/`); },
    },
    filters: {
      username(val) {
        if(val) return val.toLowerCase();
        return "unassigned";
      }
    },
    mounted: function(){
      if(typeof this.heading === 'string'){
        this.cardHeading = this.heading;
      }
      let retHistory = session.get(`/accounts/${this.id}/leads/retention/`);
      retHistory.then((ret)=>{
        let data = ret.data;
        data.forEach(d=>{
          let t = d.cancellation_records.length;
          let s = 0;
          d.cancellation_records.forEach(cr=>{ if(cr.status==='Saved'){ s++; } });
          let saved = s+'/'+t
          let preD = {
            id: d.id,
            created: d.creation_timestamp,
            agent: d.agent_sid,
            status: d.status,
            saved: saved
          };
          if(!this.filter || (this.filter!==false && d.id!==parseInt(this.filter))){ this.body.push(preD); }
        });
        this.loading = false;
      });
    }
  };
</script>

<style lang="scss" scoped>
</style>
